"use client";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

interface YotoIconProps {
  sx?: SxProps<Theme>;
  size?: number;
  alt?: string;
  round?: boolean;
}

export default function YotoIcon({ sx = {}, round = true, size = 24, alt = "Yoto" }: YotoIconProps) {
  return (
    <Box
      component="img"
      src="/yoto-logo.png"
      alt={alt}
      sx={{
        width: size,
        height: size,
        borderRadius: round ? "50%" : "0%",
        display: "inline-block",
        verticalAlign: "middle",
        ...sx
      }}
    />
  );
}
